import { render, staticRenderFns } from "./create-workspace-integration-modal.vue?vue&type=template&id=20e0e1bb&"
import script from "./create-workspace-integration-modal.vue?vue&type=script&lang=js&"
export * from "./create-workspace-integration-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports